import './App.css';
import {
  ChakraProvider, Box, SimpleGrid, Text, VStack, Flex, HStack, useMediaQuery, Button, Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from '@chakra-ui/react';
import TimerPage from './components/TimerModal';
import Tiles from './components/tiles';
import { useState, useEffect } from "react";
import { IconBrandInstagram, IconBrandYoutube, IconBrandX, IconMicrophone, IconBrandFacebook, IconBrandTiktok, IconArrowUpRight, IconBooks } from '@tabler/icons-react';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Snowfall from 'react-snowfall';
import Cookies from 'js-cookie';
import Carousel from './components/Carousel';
import { useNavigate } from 'react-router-dom';

function App() {
  // Google Maps URL (replace with the desired location)
  const googleMapsUrl = 'https://www.google.com/maps?q=Foursquare+Gospel+Church+Haruna';
  const [hoveredTile, setHoveredTile] = useState(null);
  const [isLessThan900px] = useMediaQuery("(max-width: 900px)");
  const navigate = useNavigate();
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [timerRunning, setTimerRunning] = useState(true);  // Timer state
  
  // Timer logic (keeping it running independently)
  // useEffect(() => {
  //   let timer;
  //   if (timerRunning) {
  //     // Start or keep the timer running
  //     timer = setInterval(() => {
  //       // Timer update logic, e.g., update a countdown or similar
  //       console.log("Timer is running");
  //     }, 1000); // Update every second
  //   }
  //   return () => clearInterval(timer); // Clean up timer when the component is unmounted
  // }, [timerRunning]); // This will run the effect whenever timerRunning changes
  
  // Modal control functions
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleMouseEnter = (id) => setHoveredTile(id);
  const handleMouseLeave = () => setHoveredTile(null);

  const tiles = new Array(10).fill(null);
   // Number of rows and tiles per row
  const rows = 5;
  const tilesPerRow = 2;
  // Social media links with display names and image paths

   // Carousel images
  const carouselImages = [
    'https://drive.google.com/file/d/1AU6ku5uWNeSEE1GDOVGc7o0xZU-JIoNW/view?usp=drive_link',
    'https://drive.google.com/file/d/1LtnHEM0aoA0j8R5GvmKw-xmA7DV4HzYn/view?usp=drivesdk',
    'https://via.placeholder.com/800x300?text=Image+2',
    'https://via.placeholder.com/800x300?text=Image+3',
    'https://via.placeholder.com/800x300?text=Image+4',
    // 'https://via.placeholder.com/800x300?text=Image+4'
  ];
  
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Move to the next image every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % carouselImages.length);
    }, (carouselImages + 1 == 2) ? 10000 : 5000);
    return () => clearInterval(interval);
  }, []);


  const icons = [
    { icon: <IconBrandYoutube size={100} stroke={1} />, id: 5, name: 'YouTube', url: 'https://m.youtube.com/@fgcharuna' },
    { icon: <IconMicrophone size={100} stroke={1} />, id: 1, name: 'Mixlr', url: 'https://fgcharuna.mixlr.com' },
    { icon: <IconBrandFacebook size={100} stroke={1} />, id: 1, name: 'Facebook', url: 'https://www.facebook.com/Haruna4square' },
    { icon: <IconBrandInstagram size={100} stroke={1} />, id: 3, name: 'Instagram', url: 'https://www.instagram.com/fgcharuna/?igsh=OHplOTNheHU3emY0' },
    { icon: <IconBrandX size={100} stroke={1} />, id: 4, name: 'X', url: 'https://x.com/fgcharuna' },
    { icon: <IconBrandTiktok size={100} stroke={1} />, id: 6, name: 'TikTok', url: 'http://www.tiktok.com/@fgcharuna' },
    { icon: <IconBrandInstagram size={100} stroke={1} />, id: 7, name: 'Instagram (Youths)', url: 'https://www.instagram.com/4sqharuna_youths/?igsh=Y2d0azZ2MXgyYm9l' },
    { icon: <IconBrandYoutube size={100} stroke={1} />, id: 8, name: 'YouTube (Youths)', url: 'https://www.youtube.com/@foursquareyouthsharuna5042' },
    { icon: <IconBooks size={100} stroke={1} />, id: 9, name: 'Books', url: 'https://drive.google.com/drive/folders/13X_Zdxx-XJYPkrr1O7OlBgezXWL7JqiO?usp=drive_link' },
    // { icon: <IconBrandYoutube size={100} stroke={1} />, id: 10, name: '', url: '' },
  ];

  const smallIcons = [
    { icon: <IconBrandYoutube size={50} stroke={1} />, id: 5, name: 'YouTube', url: 'https://m.youtube.com/@fgcharuna' },
    { icon: <IconMicrophone size={50} stroke={1} />, id: 1, name: 'Mixlr', url: 'https://fgcharuna.mixlr.com' },
    { icon: <IconBrandFacebook size={50} stroke={1} />, id: 1, name: 'Facebook', url: 'https://www.facebook.com/Haruna4square' },
    { icon: <IconBrandInstagram size={50} stroke={1} />, id: 3, name: 'Instagram', url: 'https://www.instagram.com/fgcharuna/?igsh=OHplOTNheHU3emY0' },
    { icon: <IconBrandX size={50} stroke={1} />, id: 4, name: 'X', url: 'https://x.com/fgcharuna' },
    { icon: <IconBrandTiktok size={50} stroke={1} />, id: 6, name: 'TikTok', url: 'http://www.tiktok.com/@fgcharuna' },
    { icon: <IconBrandInstagram size={50} stroke={1} />, id: 7, name: 'Instagram (Youths)', url: 'https://www.instagram.com/4sqharuna_youths/?igsh=Y2d0azZ2MXgyYm9l' },
    { icon: <IconBrandYoutube size={50} stroke={1} />, id: 8, name: 'YouTube (Youths)', url: 'https://www.youtube.com/@foursquareyouthsharuna5042' },
    { icon: <IconBooks size={50} stroke={1} />, id: 9, name: 'Books', url: 'https://drive.google.com/drive/folders/13X_Zdxx-XJYPkrr1O7OlBgezXWL7JqiO?usp=drive_link' },
    // { icon: <IconBrandYoutube size={50} stroke={1} />, id: 10, name: '', url: '' },
  ];

  const [seconds, setSeconds] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
  
    // Retrieve the countdown time from cookies when the page loads
    useEffect(() => {
      const countdownTime = Cookies.get('countdownTime');
      if (countdownTime) {
        setSeconds(parseInt(countdownTime, 10));  // Use as seconds
        setIsRunning(true);
      }
    }, []);
  
    // Countdown logic
    useEffect(() => {
      let timer;
      if (isRunning && seconds > 0) {
        timer = setInterval(() => {
          setSeconds((prevSeconds) => {
            const updatedSeconds = prevSeconds - 1;
            Cookies.set('countdownTime', updatedSeconds);  // Update cookie
            return updatedSeconds;
          });
        }, 1000);
      } else if (seconds <= 0) {
        clearInterval(timer);
        Cookies.remove('countdownTime');  // Clear the cookie when finished
      }
  
      return () => clearInterval(timer);
    }, [isRunning, seconds]);
  
    // Format seconds into mm:ss
    const formatTime = (secs) => {
      const minutes = Math.floor(secs / 60);
      const remainingSeconds = secs % 60;
      return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    };

  return (
    // <ChakraProvider>
      <Box className="main-container" display="flex" flexDirection="column" alignItems="center">
      <Header />
      {/* <Carousel /> */}
      {/* Carousel */}
        <Box w="100%" minH="300px" mb="20px">
          <Image
            src={`/carouselImages${currentImageIndex + 1}.${currentImageIndex + 1 === 2 ? "png" : "jpg"}`} 
            alt={`Carousel image ${currentImageIndex + 1}`}
            width="100%" // Ensures it scales with the container width
            height="auto" // Maintains aspect ratio dynamically
            objectFit="contain" // Keeps the full image visible without cropping
          />
        </Box>    
        <Box mb={4}>
          <Button onClick={() => navigate('/newyear')} colorScheme="yellow" variant="solid">
            Open Countdown
          </Button>
        </Box>
        <Box className="main-container" display="flex" flexDirection="column" alignItems="center">
          {/* Grid of Boxes */}
          <Box display="flex" flexDirection="column" alignItems="center" width="100%">
            {isLessThan900px ? (
            // Static layout for smaller screens
            <Flex wrap="wrap" justify="center" gap="10px" p={2}>
                {smallIcons.map((icon, index) => (
                <a
                  key={index}
                  href={icon.url}
                  target="_blank"
                  rel="noopener noreferrer" // Security best practice
                  style={{ textDecoration: 'none' }} // Removes underline from text
                >
                  <Box
                    key={index}
                    width="170px"
                    height="170px"
                    bg="gray.200"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                    borderRadius={10}
                  >
                    {icon.icon}
                    <Text mt={2} fontSize="sm">{icon.name}</Text>
                    </Box>
                  </a>
              ))}
            </Flex>
          ) : (
            Array.from({ length: rows }).map((_, rowIndex) => (
              <Box
                key={rowIndex}
                display="flex"
                width="815px"
                height="200px"
                position="relative" // Ensure the tiles inside each row are positioned relative to this container
                mb="20px"
              >
                {/* Left Tile */}
                <Box
                  key={`left-${rowIndex}`}
                  w={hoveredTile === rowIndex * tilesPerRow + 1 ? "600px" : hoveredTile === rowIndex * tilesPerRow + 2 ? "200px" : "400px"}
                  h="200px"
                  bg="gray.100"
                  transition="width 0.5s ease"
                  onMouseEnter={() => handleMouseEnter(rowIndex * tilesPerRow + 1)}
                  onMouseLeave={handleMouseLeave}
                >
                   {/* Center the icon */}
                    <Flex justify="center" align="center" h="100%" w="100%" flexDirection="column">
                      <motion.div
                        initial={{ opacity: 1, scale: 1, x: 0, y: 0 }}
                        animate={{
                          opacity: hoveredTile === rowIndex * tilesPerRow + 1 ? 1 : 0.5,
                          scale: hoveredTile === rowIndex * tilesPerRow + 1 ? 0.6 : 1,
                          x: hoveredTile === rowIndex * tilesPerRow + 1 ? 240 : 0,
                          y: hoveredTile === rowIndex * tilesPerRow + 1 ? -40 : 0,
                          transition: { duration: 0.5 },
                        }}
                      >
                        {icons[rowIndex * tilesPerRow]?.icon}
                      </motion.div>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{
                          opacity: hoveredTile === rowIndex * tilesPerRow + 1 ? 0 : 1,
                          transition: { duration: 0.3 },
                        }}
                      >
                        <Text mt={2} textAlign="center" className={icons[rowIndex * tilesPerRow]?.name ===  "Instagram" ? 'billabong' : ''} fontSize={'2xl'}>{icons[rowIndex * tilesPerRow]?.name}</Text>
                      </motion.div>
                  </Flex>
                  {/* Go to Site Button */}
                    {hoveredTile === rowIndex * tilesPerRow + 1 && (
                      <a
                        href={icons[rowIndex * tilesPerRow]?.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none' }}
                      >
                        <Box
                          position="absolute"
                          bottom="10px"
                          right="235px"
                          bg="black"
                          color="white"
                          px={7}
                          py={1.5}
                          borderRadius="50px"
                          fontSize="sm"
                          textAlign="center"
                          cursor="pointer"
                        >
                          <HStack>
                            <span>Go to Site</span>
                            <IconArrowUpRight />
                          </HStack>
                        </Box>
                      </a>
                    )}
                    {/* Display name at the center of the screen */}
                    {hoveredTile === rowIndex * tilesPerRow + 1 && (
                      <Text
                        position="absolute"
                        top="50%"
                        left="50%"
                        transform="translate(-150%, -50%)"
                        fontSize="3xl"
                        // fontWeight="bold"
                        color="black"
                        zIndex={10}
                        className={icons[rowIndex * tilesPerRow]?.name === 'Instagram' ? 'billabong' : ''}   
                        
                      >
                        {icons[rowIndex * tilesPerRow]?.name}
                      </Text>
                  )}
                </Box>

                {/* Right Tile */}
                <Box
                  key={`right-${rowIndex}`}
                  w={hoveredTile === rowIndex * tilesPerRow + 2 ? "600px" : hoveredTile === rowIndex * tilesPerRow + 1 ? "200px" : "400px"}
                  h="200px"
                  bg="gray.100"
                  transition="width 0.5s ease"
                  position="absolute"
                  right="0"
                  onMouseEnter={() => handleMouseEnter(rowIndex * tilesPerRow + 2)}
                  onMouseLeave={handleMouseLeave}
                >
                  {/* Center the icon */}
                  <Flex justify="center" align="center" h="100%" w="100%" flexDirection="column">
                    <motion.div
                      initial={{ opacity: 1, scale: 1, x: 0, y: 0 }}
                      animate={{
                        opacity: hoveredTile === rowIndex * tilesPerRow + 2 ? 1 : 0.5,
                        scale: hoveredTile === rowIndex * tilesPerRow + 2 ? 0.6 : 1,
                        x: hoveredTile === rowIndex * tilesPerRow + 2 ? 240 : 0,
                        y: hoveredTile === rowIndex * tilesPerRow + 2 ? -40 : 0,
                        transition: { duration: 0.5 },
                      }}
                    >
                      {icons[rowIndex * tilesPerRow + 1]?.icon}
                    </motion.div>
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{
                        opacity: hoveredTile === rowIndex * tilesPerRow + 2 ? 0 : 1,
                        transition: { duration: 0.3 },
                      }}
                    >
                      <Text mt={2} textAlign="center" fontSize={'2xl'}>{icons[rowIndex * tilesPerRow + 1]?.name}</Text>
                    </motion.div>
                  </Flex>

                  {/* Go to Site Button */}
                  {hoveredTile === rowIndex * tilesPerRow + 2 && (
                    <a
                      href={icons[rowIndex * tilesPerRow + 1]?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none' }}
                    >
                      <Box
                        position="absolute"
                        bottom="10px"
                        right="10px"
                        bg="black"
                        color="white"
                        px={7}
                        py={1.5}
                        borderRadius="50px"
                        fontSize="sm"
                        textAlign="center"
                        cursor="pointer"
                      >
                        <HStack>
                          <span>Go to Site</span>
                          <IconArrowUpRight />
                        </HStack>
                      </Box>
                    </a>
                  )}
                  {/* Display name at the center of the screen */}
                  {hoveredTile === rowIndex * tilesPerRow + 2 && (
                    <Text
                      position="absolute"
                      top="50%"
                      left="50%"
                      transform="translate(-50%, -50%)"
                      fontSize="3xl"
                      // fontWeight="bold"
                      color="black"
                      zIndex={10}
                    >
                      {icons[rowIndex * tilesPerRow + 1]?.name}
                    </Text>
                  )}
                </Box>
              </Box>
            ))
          )}
          </Box>
         </Box>

        {/* Modal for TimerPage */}
        <Modal isOpen={isModalOpen} onClose={closeModal} isCentered size="full">
          <ModalOverlay />
          <ModalContent
            bg="black"
            color="white"
            width="70vw"
            height="70vh"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            alignItems="center"
          >
            <ModalHeader>Countdown Timer</ModalHeader>
            <ModalCloseButton />
            <ModalBody display="flex" flexDirection="column" justifyContent="center" alignItems="center" flexGrow={1}>
              <h2 style={{ fontSize: '8rem', fontWeight: 'bold' }}>{formatTime(seconds)}</h2>
              {!isRunning && seconds === 0 && <p style={{ fontSize: '2rem' }}>Time's up!</p>}
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="red" mr={3} onClick={closeModal}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    // {/* </ChakraProvider> */}
  );
}

export default App;
